import { Breadcrumbs, Button, Card, CardContent, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { PdfViewer } from '../components/atoms/inputs/PdfViewer';
import { AppShell } from '../components/molecules/app-shell/AppShell';
import { useStore } from '../store';




const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    centerButton: {
        justifyContent: 'center',
        display: 'flex',
    },

}))


type PPODetailPageProps = {
}

export const PPODetailPage: FunctionComponent<PPODetailPageProps> = () => {
    const classes = useStyles()
    const store = useStore()

    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Grid item>
                    <Card className={classes.controlPaper}>
                        <CardContent>
                            <Grid container spacing={3} direction="column" justify="space-around"
                                alignItems="stretch">
                                <Grid item>
                                    <Breadcrumbs>
                                        <Link to="/" className={classes.link}>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                <HomeIcon className={classes.icon} />
                                                Home
                                            </Typography>
                                        </Link>
                                        <Typography gutterBottom variant="h5" component="h2">
                                            PPO Details (পেনশন পেমেন্ট অর্ডারের বিবরণ)
                                        </Typography>
                                    </Breadcrumbs>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                < Grid item>
                    <Card >
                        <CardContent>
                            <PdfViewer
                                showDigitalCertDeclaration={true}
                                downloadFileName="ppo.pdf"
                                file={{
                                    url: `${process.env.REACT_APP_API_ROOT}api/pensioner/ppo`,
                                    httpHeaders: { 'Authorization': `Bearer ${store.auth.jwt}`, 'JWT': `Bearer ${store.auth.jwt}` },
                                }}
                                error={
                                    <>
                                        <Typography
                                            variant="h6"
                                            component="h6"
                                            style={{ textAlign: "center" }}
                                            color="secondary"
                                        >Unable to load PDF (পিডিএফ লোড করতে অক্ষম)</Typography>
                                    </>
                                }
                            />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item className={classes.centerButton}>
                    <Link to="/" className={classes.link}>
                        <Button variant="contained" color="primary" size="large">
                            Back (পিছনে)
                        </Button>
                    </Link>
                </Grid>
            </Grid>
        </AppShell >
    )
}